// extracted by mini-css-extract-plugin
module.exports = {"container":"EditTelInput_container__36s5s","error":"EditTelInput_error__mTotI"};